import { render, staticRenderFns } from "./PricingEquipment.vue?vue&type=template&id=15d00524&scoped=true&"
import script from "./PricingEquipment.vue?vue&type=script&lang=js&"
export * from "./PricingEquipment.vue?vue&type=script&lang=js&"
import style0 from "./PricingEquipment.vue?vue&type=style&index=0&id=15d00524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d00524",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VSwitch,VTextField})
